import React from 'react'
import "./nursing.css"
import CustomTitle from '../CustomTitle/CustomTitle.jsx'








export default function Nursing() {

   return (
      <>
         <div className="container">
            <CustomTitle title="التمريض" />

            <h2 className='main-header mt-5 pt-5'>Nursing Profile</h2>
            <div className='under-header'></div>

            <div className="row">
               <p>Not Found Data Today`s !</p>
            </div>
         </div>
      </>
   )
}
